import React, { useState, useMemo, useCallback, Suspense } from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';

// Lazy load the SecurityReviewApp component
const SecurityReviewApp = React.lazy(() => import('./SecurityReviewApp'));

// Error Boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

const LandingPageWithRouter = React.memo(() => {
  const navigate = useNavigate();
  const handleGetStarted = useCallback(() => {
    navigate('/app');
  }, [navigate]);

  return <LandingPage onGetStarted={handleGetStarted} />;
});

const App = () => {
  const [mode] = useState('light');
  
  const theme = useMemo(() => createTheme({
    palette: { mode },
  }), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <Router>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route exact path="/" element={<LandingPageWithRouter />} />
              <Route path="/app" element={<SecurityReviewApp />} />
            </Routes>
          </Suspense>
        </Router>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default App;